import { render, staticRenderFns } from "./NuevaEntrada.vue?vue&type=template&id=5b7bf29e"
import script from "./NuevaEntrada.vue?vue&type=script&lang=js"
export * from "./NuevaEntrada.vue?vue&type=script&lang=js"
import style0 from "./NuevaEntrada.vue?vue&type=style&index=0&id=5b7bf29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports